var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBagActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 200",
    style: {
      enableBackground: "new 0 0 171 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#6A0DAD;stroke:#FFFFFF;stroke-width:0.5;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.2,159.7L165,68.1c-0.6-9.8-8.7-17.5-18.5-17.5h-22.1l-1-12.6c-0.8-20.7-17.5-37.2-38.2-37.8 C81.1,0.2,77,1,73.1,2.4C70.4,3.2,69,6,69.8,8.7c0.8,2.7,3.7,4.2,6.3,3.3c0.1,0,0.2-0.1,0.4-0.1c2.8-1,5.8-1.5,8.8-1.5 c15.3,0.8,27.5,13.1,28.1,28.5l0.9,11.8H56.2l0.9-11.8c0.3-4.3,1.5-8.5,3.4-12.3c1.3-2.5,0.3-5.5-2.2-6.8c-2.5-1.3-5.5-0.3-6.8,2.2 c0,0,0,0,0,0.1c-2.5,5-4,10.5-4.4,16l-1,12.6H24c-9.8,0-17.9,7.7-18.5,17.5l-5.2,91.6c-1.2,20.6,14.6,38.3,35.2,39.4 c0.7,0,1.4,0.1,2.1,0.1h95.2c20.6,0,37.4-16.7,37.4-37.4C170.3,161.2,170.2,160.5,170.2,159.7z M134.4,189.1c-0.5,0-1,0-1.5,0H37.7 c-15.1,0-27.3-12.2-27.3-27.3c0-0.5,0-1,0-1.6l5.2-91.6c0.3-4.5,4-7.9,8.4-7.9h21.3l-1.3,17.8c-0.2,2.8,1.9,5.2,4.6,5.4H49 c2.6,0,4.8-2,5-4.7l1.4-18.5l59.7,0.1l1.4,18.5c0.2,2.6,2.4,4.7,5,4.7h0.4c2.8-0.2,4.8-2.6,4.6-5.4l-1.3-17.8h21.3 c4.5,0,8.1,3.5,8.4,7.9l5.2,91.6C160.9,175.4,149.4,188.2,134.4,189.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBagActive);
export default __webpack_public_path__ + "static/media/shoppingBagActive.08af68aa1a1924ad8d68a6ec502cb98e.svg";
export { ForwardRef as ReactComponent };